import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import Tabs from "@mui/material/Tabs";
import AppBar from "@mui/material/AppBar";
import Hidden from "@mui/material/Hidden";
import { useHistory } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import MenuItem from "@mui/material/MenuItem";
import React, { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";

import { logoutUser } from "../../api/auth";
import { LO_STO } from "../../util/constants";
import BaseAvatar from "../BaseComponents/BaseAvatar";
import { ActionButtons, HeaderContainer, OverlapComponent, styles } from "./styles";

function Header({
  classes,
  rootUrl,
  onDrawerToggle,
  headerTitle,
  headerSecondaryTitle,
  tabs,
  defaultTab,
  actionButtons,
  overlapComponent
}) {
  const [selectedTab, setSelectedTab] = useState(defaultTab);
  const [anchorEl, setAnchorEl] = useState(null);
  const [user, setUser] = useState(null);
  const history = useHistory();

  window.onpopstate = () => {
    const queryString = window.location.pathname;
    const activeTabName = queryString.split("/").pop();
    const activeTab = tabs?.find((tab) => tab.id === activeTabName);
    activeTab && setSelectedTab(activeTab.id);
  };

  useEffect(() => {
    const name = window.localStorage.getItem(LO_STO.CURRENT_NAME);
    const userId = window.localStorage.getItem(LO_STO.USER_ID);
    setUser({ name, userId });
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTabClick = (tab) => {
    history.push(`${rootUrl}/${tab.id}`);
    setSelectedTab(tab.id);
  };

  return (
    <HeaderContainer>
      <AppBar sx={{ height: "48px" }} color="primary" position="sticky" elevation={0}>
        <Toolbar>
          <Grid container spacing={1} alignItems="center">
            <Hidden smUp>
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={onDrawerToggle}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            </Hidden>
            <Grid item xs />
            <Grid item>
              <IconButton color="inherit" className={classes.iconButtonAvatar} onClick={handleClick}>
                <BaseAvatar {...user} />
              </IconButton>
              <Menu
                id="simple-menu"
                className={classes.logoutButton}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose && logoutUser}>Logout</MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar component="div" className={classes.primaryBar} color="primary" position="static" elevation={0}>
        <Toolbar className={classes.fixedWidth}>
          <Grid container direction="row" alignItems="center" spacing={1} justify="space-between">
            <Grid item>
              <Typography color="inherit" variant="h5" component="h1">
                {headerTitle}
              </Typography>
              {headerSecondaryTitle}
            </Grid>
            <Grid item>
              <ActionButtons>
                {actionButtons &&
                  actionButtons.map((btn, idx) => {
                    return (
                      btn.enabled && (
                        <button key={idx} onClick={btn.action}>
                          {btn.label}
                        </button>
                      )
                    );
                  })}
              </ActionButtons>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar component="div" className={classes.secondaryBar} color="primary" position="static" elevation={0}>
        <div className={classes.fixedWidth}>
          <Tabs value={selectedTab} textColor="inherit">
            {tabs?.map((tab, i) => {
              return (
                <Tab key={i} textColor="inherit" value={tab.id} label={tab.label} onClick={() => handleTabClick(tab)} />
              );
            })}
          </Tabs>
        </div>
      </AppBar>
      <OverlapComponent>{overlapComponent}</OverlapComponent>
    </HeaderContainer>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Header);
